import apiFetch from '../apiFetch'

export default function (list, token) {
  return apiFetch({endPoint: `CambioEstadoVerraco/deleteSeleccionCambioEstadoVerraco`, method: 'POST', body: {list}, token: token})
}
